

















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class AppendixInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '附件',
    required: false,
  };
  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
